import React from 'react'; 
import ProjectPage from './ProjectPage';
import PageFooter from '../page/PageFooter';
import WithConsumer from '../../context/WithConsumer';

const Project = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
            
    if (post) {
	    
		if (post.accent_color) {
		    document.getElementsByClassName('c-cover')[0].style.backgroundColor = post.accent_color;
	    }
		let logoColor = 'black';
	    if (post.logo_color) {
		    logoColor = post.logo_color;
	    } else if (post.accent_colour_text == 'light') {
		    logoColor = 'white';
	    }
	    document.documentElement.style.setProperty('--logo-color', logoColor);
	    
	    let pageClass = 'c-page-wrapper c-page c-page-' + post.slug;
		
		if (context.appError || post.type != 'project'){
		
			return null; 
		
		} else {
				
			return (
				<>

					<div className={pageClass}>
						
						<div className="c-page__inner">
							
							<ProjectPage post={post}></ProjectPage>
									
						</div>
					</div>
					
				</>
			)
						
		}

	} else {
		return null;
	}
};
export default WithConsumer(Project);